import axios from '@/api'

export default {
  namespaced : true,
  state : {
    stats : {
      partners: {
        total: 0
      },
      users: {
        total: 0
      },
      trips: {
        total: 0,
        pending: 0
      },
      vehicles: 0,
      balance: {
        free: 0,
        card: 0
      },
      booking: {
        cancelled: 0,
        total: 0,
        pending: 0
      }
    }
  },
  getters : {

  },
  mutations : {
    SET_STATS(state, payload){
      state.stats = payload;
    },
  },
  actions: {
    fetchStats({ commit },payload){
      return new Promise((resolve, reject) => {
        axios.get(`/admin/stats`,{params:  payload})
          .then((response) => {
            commit('SET_STATS', response.data.stats);
            resolve(response.data.stats)
          })
          .catch((error) => { reject(error) })
      })
    },
  }
}
